import React from 'react';
import styles from './index.modules.scss';
import { Progress as MProgress } from '@mantine/core';

const matchStyle = {
  default: styles.default,
  warning: styles.warning,
  error: styles.full,
};

/**
 * 详见https://mantine.dev/core/progress/
 *
 * @param {*} props type: default,warning,error 控制进度条的颜色
 * @returns
 */
export const Progress = (props) => {
  const { className, type = 'default', ...rest } = props;

  return <MProgress className={`${styles.progress} ${className} ${matchStyle[type]}`} radius="lg" {...rest} />;
};
